import { TablePagination, TablePaginationProps, LabelDisplayedRowsArgs } from '@mui/material';

import TablePaginationActions from './components/TablePaginationActions';

const Pagination: React.FC<TablePaginationProps> = props => {
  const { count, page, rowsPerPage, onPageChange, ...restProps } = props;

  const getLabelDisplayedRows = (paginationInfo: LabelDisplayedRowsArgs): React.ReactNode => {
    const { from, to, count: paginationInfoCount } = paginationInfo;
    return `Showing ${from}–${to} of ${paginationInfoCount !== -1 ? paginationInfoCount : `more than ${to}`}`;
  };

  return (
    <TablePagination
      {...restProps}
      count={count || 0}
      page={page - 1}
      rowsPerPage={rowsPerPage}
      onPageChange={onPageChange}
      labelDisplayedRows={getLabelDisplayedRows}
      ActionsComponent={TablePaginationActions}
      component="div"
    />
  );
};

export default Pagination;
